(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["avila-product-card"] && !Shopify.designMode) return;
  try {
    /* ============================================================
   AVILA PRODUCT CARD — Quick-Add JS
   Event delegation on document.body so it handles every card
   on the page regardless of when they were rendered.

   Single-variant  → POST /cart/add.js → dispatch cart:updated
   Multi-variant   → navigate to product URL

   The + button is no longer nested inside the card link, so it
   cannot trigger PDP navigation on its own. preventDefault /
   stopPropagation are kept as defensive belt-and-suspenders.
   ============================================================ */
(function () {
  'use strict';

  /* One-time init guard — prevents duplicate listeners when the
     snippet is rendered multiple times in a loop. */
  if (window.__avilaCardQAInited) return;
  window.__avilaCardQAInited = true;

  document.body.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-avila-quickadd]');
    if (!btn) return;

    /* Defensive: stop any ancestor link from navigating */
    e.preventDefault();
    e.stopPropagation();

    var variantId    = btn.getAttribute('data-variant-id');
    var needsOptions = btn.getAttribute('data-needs-options') === 'true';
    var productUrl   = btn.getAttribute('data-product-url');

    /* Needs a real option choice (apparel size/colour): open the PDP.
       Everything else (chalk packs, bundles) adds the default variant. */
    if (needsOptions) {
      window.location.href = productUrl;
      return;
    }

    /* Direct add: POST the default/first available variant to cart */
    if (!variantId) return;
    if (btn.classList.contains('avila-qa-loading')) return;

    btn.classList.add('avila-qa-loading');
    btn.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      /* Ask Shopify to return the re-rendered cart sections in the same
         request so we can update the header bubble + drawer with no reload. */
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('cart add ' + res.status);
      return res.json();
    })
    .then(function (response) {
      btn.classList.remove('avila-qa-loading');
      btn.classList.add('avila-qa-added');
      btn.textContent = '✓';

      var sections = response.sections || {};
      var cartDrawer = document.querySelector('cart-drawer');

      /* PREFERRED PATH — hand the response to Dawn's own cart drawer.
         renderContents() updates the header bubble AND the drawer markup,
         re-binds the overlay close handler (so clicking off works), and
         opens the drawer. This is exactly what Dawn's built-in quick-add
         does, so behaviour matches the rest of the theme. */
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(response);

        /* This theme keeps the empty-state class on <cart-drawer> and
           <cart-drawer-items>, but Dawn's renderContents only clears it from
           .drawer__inner — so adding the FIRST item from an empty cart can
           leave the drawer stuck in its empty layout. Clear it explicitly. */
        cartDrawer.classList.remove('is-empty');
        var drawerItems = cartDrawer.querySelector('cart-drawer-items');
        if (drawerItems) drawerItems.classList.remove('is-empty');
      } else {
        /* FALLBACK — manual swap for themes without a cart drawer. */
        function sectionInner(html, selector) {
          if (!html) return null;
          var el = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector);
          return el ? el.innerHTML : null;
        }

        /* Header cart count bubble — section is wrapped in .shopify-section */
        var liveBubble = document.getElementById('cart-icon-bubble');
        var bubbleHTML = sectionInner(sections['cart-icon-bubble'], '.shopify-section');
        if (liveBubble && bubbleHTML !== null) {
          liveBubble.innerHTML = bubbleHTML;
        }

        /* Cart drawer markup + open + re-bind overlay close */
        if (cartDrawer && sections['cart-drawer']) {
          var drawerHTML = sectionInner(sections['cart-drawer'], '#CartDrawer');
          var liveInner = cartDrawer.querySelector('#CartDrawer');
          if (drawerHTML !== null && liveInner) {
            liveInner.innerHTML = drawerHTML;
          }
          cartDrawer.classList.remove('is-empty');
          var overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
          if (overlay && typeof cartDrawer.close === 'function') {
            overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
          }
          if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          } else {
            cartDrawer.classList.add('active', 'animate');
            document.body.classList.add('overflow-hidden');
          }
        }
      }

      /* Tell the custom milestone / free-shipping bar (and any other cart
         subscribers) to recalculate. Its script listens for these events. */
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart-update', { bubbles: true }));

      /* Reset button after 1.8 s */
      setTimeout(function () {
        btn.classList.remove('avila-qa-added');
        btn.textContent = '+';
      }, 1800);
    })
    .catch(function (err) {
      console.warn('[avila-card] cart add failed:', err);
      btn.classList.remove('avila-qa-loading');
      btn.textContent = '+';
    });
  });

})();
  } catch(e) { console.error(e); }
})();

})();
